<template> 
    <div>
        <div class="main-title">APPLICATION SUBMITTED</div>
        <div class="main-title">WOO HOO!</div>
        <v-row class="body-text" justify="center">
            <v-col cols="12" sm="10" md="8" lg="7">
                <div>Congratulations on submitting your application for  {{ scholarname || 'a GO-PEF Scholarship' }}. We are SO proud of you and thank you for taking all that time to submit an application.</div>
                <br />
                <div>We know that it wasn't easy and we asked some pretty hard questions but that's because we care. We want to make sure that you get the most out of a scholarship and we want to ensure that our scholarships are making a difference. At GO, we care about your future and that means that it won't always be easy.</div>
                <br />
                <div>Good Luck! We can't wait to read your application. We will be in touch at the end of November with further information. Until then, we will not be able to give you an update on your application.</div>
                <br />
                <div>Thank you from everyone at GO!</div>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    props: {
        application_id: [Number, String],
    },
    data() {
        return {
            scholarname: "",
        };
    },
    async beforeMount() {
        console.log('app submitted');
            console.log(this.$store.getters['stage/scholarship']);
            console.log(this.$store.getters['stage/scholarship'].Name);
            console.log(this.$store.getters['stage/scholarship'].Name.split('|')[0]);
            this.scholarname = this.$store.getters['stage/scholarship'].Name.split('|')[0];
        
        
    }
}
</script>
<style lang="scss" scoped>
.main-title {
    font-family: $body-font-family;
    font-size: 30px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 4px;
    text-align: center;
    margin-bottom: 30px;
}
.sub-title {
    font-family: $body-font-family;
    font-size: 24px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 3.2px;
    text-align: center;
    margin-bottom: 20px;
}
.body-text {
    font-family: $secondary-font;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
}

</style>
